import StatusPill, { type Tone } from '@/components/console/status-pill';
import type { Message } from '@/types/platform';

const STATUSES: Record<Message['status'], { text: string; tone: Tone }> = {
  queued: { text: 'Queued', tone: 'neutral' },
  sent: { text: 'Sent', tone: 'success' },
  // Recorded by the stand-in mail service. Nothing left the app.
  simulated: { text: 'Demo', tone: 'warning' },
  failed: { text: 'Failed', tone: 'danger' },
  blocked: { text: 'Blocked', tone: 'danger' },
};

const MessageStatusPill = ({ status }: { status: Message['status'] }) => {
  const { text, tone } = STATUSES[status];

  return <StatusPill tone={tone}>{text}</StatusPill>;
};

export default MessageStatusPill;
